import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";

/**
 * MarketingPhrasesRow
 * - Ornaments stay next to phrases (no edge spreading)
 * - Responsive: wraps/condenses on smaller screens
 */
export function MarketingPhrasesRow({
                                        leftSrc,
                                        rightSrc,
                                        color,
                                        phrases = ["Phrase 1", "Phrase 2", "Phrase 3"],
                                        maxWidth = 1400,
                                        minHeight = 44,
                                        ornamentHeight = { xs: 60, sm: 70, md: 90 },
                                        phraseGap = { xs: 2, sm: 6, md: 12 },
                                        wrapOnMobile = true,
                                    }) {
    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
            }}
        >
            {/* Outer container just centers content */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth,
                    minHeight,
                    px: { xs: 2, sm: 3, md: 4 },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {/* This row hugs its content so ornaments sit next to phrases */}
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        width: "fit-content",
                        maxWidth: "100%",
                        gap: { xs: 1.5, sm: 2, md: 2.5 }, // ornament-to-text spacing
                    }}
                >
                    {/* Left ornament */}
                    {leftSrc ? (
                        <Box
                            component="img"
                            src={leftSrc}
                            alt=""
                            aria-hidden="true"
                            sx={{
                                height: ornamentHeight,
                                width: "auto",
                                flexShrink: 0,
                                objectFit: "contain",
                            }}
                        />
                    ) : null}

                    {/* Phrases */}
                    <Stack
                        direction={wrapOnMobile ? { xs: "column", sm: "row" } : "row"}
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            maxWidth: "100%",
                            columnGap: phraseGap,
                            rowGap: { xs: 0.75, sm: 0 },
                            flexWrap: wrapOnMobile ? { sm: "wrap" } : "nowrap",
                            textAlign: "center",
                        }}
                    >
                        {phrases.map((text) => (
                            <Typography
                                key={text}
                                sx={{
                                    color: color,
                                    fontFamily: `"Georgia", "Times New Roman", serif`,
                                    fontWeight: 500,
                                    fontSize: { xs: 14, sm: 16, md: 20 },
                                    letterSpacing: { xs: "0.12em", sm: "0.14em", md: "0.18em" },
                                    whiteSpace: wrapOnMobile ? { xs: "normal", sm: "nowrap" } : "nowrap",
                                    lineHeight: 1.2,
                                }}
                            >
                                {text}
                            </Typography>
                        ))}
                    </Stack>

                    {/* Right ornament */}
                    {rightSrc ? (
                        <Box
                            component="img"
                            src={rightSrc}
                            alt=""
                            aria-hidden="true"
                            sx={{
                                height: ornamentHeight,
                                width: "auto",
                                flexShrink: 0,
                                objectFit: "contain",
                            }}
                        />
                    ) : null}
                </Stack>
            </Box>
        </Box>
    );
}
